const installationInstructions = {
  intro: {
    currentStep: 'intro',
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    // prevStep: N/A
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    resource: require('@/assets/device-models/PEK-33/pek_33.png'),
    haloDeviceResource: require('@/assets/device-models/PEK-33/pek_33_halo.png'),
    resourceType: 'image',
    primaryText: 'Congratulations on getting a 15A Smart Plug!',
    secondaryText: 'Let’s get started with pairing your new device',
    continueButtonText: 'Start pairing',
  },
  letsGetStarted: {
    currentStep: 'letsGetStarted',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/device-models/PEK-33/pek_33_verify.png'),
    resourceType: 'image',
    primaryText: 'Verify device is in pairing mode',
    secondaryText: 'It may take a few minutes after powering on the smart plug before it is in pairing mode. Follow these steps to confirm:',
    continueButtonText: 'Ready',
    steps: [
      {
        title: 'Plug device into outlet',
        description: 'The light on the front of your smart plug will turn on when it is connected to power.',
        stepNumber: 1
      },
      {
        title: 'Blinking light pattern',
        description: 'When the smart plug is in pairing mode the light will turn to a double blinking green.',
        stepNumber: 2
      },
    ],
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      title: 'Read instructions',
    }
  },
  pairingModeReset: {
    prevStep: 'letsGetStarted',
    headerIcon: 'arrowGrey',
    prevStepName: 'instructions',
    currentStep: 'pairingModeReset',
    resourceType: 'image',
    resource: require('@/assets/device-models/PEK-33/pek_33_reset.png'),
    resourceOverridingClass: 'background-none',
    primaryText: 'Putting 15A Smart Plug into pairing mode',
    secondaryText: 'If the light on the front of the device is not double blinking green, it is not in pairing mode. To manually put the 15A Smart Plug into pairing mode:',
    steps: [
      {
        title: 'Press and hold',
        description: 'Press and hold the button on the side of your device until your light turns red. This should take around 10 seconds.',
        stepNumber: 1
      },
      {
        title: 'Release',
        description: 'Release the button as soon as you see the light turn red. You should hear a click sound at the same time.',
        stepNumber: 2
      },
      {
        title: 'Ready to pair',
        description: 'The light on the front of the device will turn to double blinking green when it is ready to pair.',
        stepNumber: 3
      },
    ],
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
  }
};

export default installationInstructions;
